import { render, staticRenderFns } from "./cardex.vue?vue&type=template&id=0976c424"
import script from "./cardex.vue?vue&type=script&lang=js"
export * from "./cardex.vue?vue&type=script&lang=js"
import style0 from "./cardex.vue?vue&type=style&index=0&id=0976c424&prod&lang=css"
import style1 from "./cardex.vue?vue&type=style&index=1&id=0976c424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports